import config from 'constants/config'

/** @returns the default / lowest ranked tier from program config with fallback */
function getLoyaltyDefaultTier(): App.LoyaltyTier {
  return config.loyalty.tiersOrder[0]
}

export default getLoyaltyDefaultTier
